module.exports = __webpack_public_path__ + "img/24_30.0b1f661f.png";